import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainSection } from './components/PainSection';
import { ProductIntro } from './components/ProductIntro';
import { TomosGrid } from './components/TomosGrid';
import { BonusGrid } from './components/BonusGrid';
import { UrgencyBanner } from './components/UrgencyBanner';
import { PricingSection } from './components/PricingSection';
import { EliteUpsell } from './components/EliteUpsell';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsFull } from './components/TestimonialsFull';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { StickyBottomCTA } from './components/StickyBottomCTA';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full min-h-screen bg-bg-primary text-white" data-id="element-0">
      <FacebookPixel data-id="element-1" />
      <Hero onCTAClick={scrollToPricing} data-id="element-2" />
      <SocialProofBar data-id="element-3" />
      <PainSection data-id="element-4" />
      <ProductIntro data-id="element-5" />
      <TomosGrid data-id="element-6" />
      <BonusGrid showFreeLabel={true} data-id="element-7" />
      <UrgencyBanner data-id="element-8" />
      <PricingSection onCTAClick={scrollToPricing} data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <TestimonialsFull data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA onCTAClick={scrollToPricing} data-id="element-14" />
      <Footer data-id="element-15" />
      <PurchasePopup data-id="element-16" />
      <StickyBottomCTA onCTAClick={scrollToPricing} data-id="element-17" />
    </div>;
}